// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useContext, useEffect, useState} from 'react';
import cn from 'classnames';
import styles from './article.module.less';
import {Settings_context} from '../../../settings_ctx';
import {statuses} from '../../../data_ctx';
import etask from 'zetask';
import {use_data_provider} from '../../../lib/use_data_provider';
import {Share} from '../../../ui/blog/share';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {get_article_date, i_article_result} from '../../../ui/blog/i_blog';
import {Link} from 'react-router-dom';
// @ts-ignore
import {perr_www_visit} from '/www/hola/pub/util.js';
// @ts-ignore
import {App_context} from '/www/hola/pub/context.js';

const get_data_id = params=>`/blog/article/slug/${params.slug}/id/${params.id}`;

export const Root = ()=>{
    const {theme} = useContext(Settings_context);
    // @ts-ignore
    const {user} = useContext(App_context);
    const {data} = use_data_provider(get_data_id);
    const [art, set_art_result] = useState(data.result as i_article_result);
    useEffect(()=>{
      if (data.status==statuses.done)
      {
          set_art_result(data.result);
          if (data.result.data)
          {
              perr_www_visit({
                  id: `www_blog_article_${data.result.data.id}_visit`,
                  user,
              });
              fetch(`/cms_api/blog/read_post?id=${data.result.data.id}`);
          }
      }
    }, [data]);
    const author_block = art && !art.error ? <div className={styles.after_img}>
      <div className={styles.author}>
        <div className={styles.author_pic}
          style={{
            backgroundImage: `url(${art.data.author.img})`,
          }}/>
          <div>
            <p className={cn(theme.p2, theme.logo_grey, styles.author_name)}>
              {art.data.author.name}
            </p>
            <p className={cn(theme.xs, theme.light)}>
              {get_article_date(art.data)}{' \u00B7 '}
              {art.data.time_to_read} read</p>
          </div>
      </div>
      <Share article_id={art.data.id} article_title={art.data.title}/>
    </div> : null;
    return <div className={cn(theme.root, styles.page)}>
      <div className={cn(theme.container, styles.container)}>
        <div className={styles.breadcrumbs}>
          <p className={theme.xs}>
            <Link to={'/blog'} className={styles.link}>Blog</Link>
            {art && !art.error && art.data.categories[0] &&
              <Link className={styles.link}
              to={`/blog/category/${art.data.categories[0].slug}`}>
              {art.data.categories[0].name}</Link>}
          </p>
        </div>
        {art && !art.error ? <Fragment>
          <h1 className={theme.H2}
            dangerouslySetInnerHTML={{__html: art.data.title}}></h1>
          <h5 dangerouslySetInnerHTML={{__html: art.data.excerpt}}></h5>
          {art.data.img && <div className={styles.img_art}>
            <img src={art.data.img} alt="article_img" className="lazyload"/>
          </div>}
          {author_block}
          <div className={styles.article_body}
            dangerouslySetInnerHTML={{__html: art.data.content}}></div>
          {author_block}
        </Fragment> : <span>{art && art.error}</span>}
      </div>
    </div>;
};
Root.meta = {
    ssr_force: true,
    meta: props=>{
      if (props.data_from_provider)
      {
          const {category} = props;
          const seo_data = props.data_from_provider?.data?.seo;
          const seo_title = seo_data?.title ||
              props.data_from_provider?.data?.title;
          const seo_description = seo_data?.description ||
              props.data_from_provider?.data?.excerpt;
          const seo_keywords = seo_data?.keywords || '';
          const seo_date = props.data_from_provider?.data?.datetime?.date;
          return {
              title: 'Hola | ' + seo_title,
              canonical_url: 'https://hola.org/blog/'+category+'/'+
                  props.data_from_provider?.data?.slug,
              og_title: 'Hola | ' + seo_title,
              description: seo_description,
              keywords: seo_keywords,
              og_description: seo_description,
              og_url: 'https://hola.org/blog/'+
                props.data_from_provider?.data?.slug,
              og_image: props.data_from_provider?.data?.img,
              author: props.data_from_provider?.data?.author?.name,
              published_time: seo_date && new Date(seo_date).toISOString(),
          };
      }
      return {
          title: 'Hola | Article',
          canonical_url: '/blog/article/slug/',
      };
  },
    set_data_cache: (data_cache, params, data)=>{
        data_cache[`/blog/article/slug/${params.slug}/id/${params.id}`] = data;
    },
    get_data_id,
    data_provider: (data_cache, params)=>etask(function*(){
        const cache_key = `/blog/article/slug/${params.slug}/id/${params.id}`;
        const cached = data_cache[cache_key];
        if (cached)
            return cached;
        if (!params.id && !params.slug)
            return {data: {}, error: 'article id should be specified'};
        const data = yield fetch(`https://hola.org/cms_api/blog/post/`+
            `?slug=${params.slug}&id=${params.id}`);
        if (!data || data.indexOf && data.indexOf('<!DOCTYPE')>-1)
            return {data: {}, error: 'not found'};
        const result = {
            data,
            error: '',
            cache_key,
        };
        data_cache[cache_key] = result;
        return result;
    }),
};
